import './Tab.scss';

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Box from 'components/Box';
import Text from 'components/Text';

import cxHelpers from 'util/className';

import { THEMES } from '../constants';

@cxHelpers('Tab')
export default class Tab extends PureComponent {
  static propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    active: PropTypes.bool,
    indicator: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    theme: PropTypes.oneOf(THEMES),
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    theme: THEMES[0],
    disabled: false,
  };

  handleSelect = () => {
    if (this.props.disabled) {
      return;
    }
    this.props.onChange(this.props.value);
  };

  render() {
    const { active, label, theme, indicator, disabled } = this.props;

    return (
      <Box
        pa12
        className={this.cx({ active, disabled, [theme]: theme })}
        tag="a"
        onClick={this.handleSelect}
        hcenter
        tcenter
        relative
      >
        {indicator && <span className="tab-notification-indicator" />}
        <Text className={this.cxEl('text')}>{label}</Text>
      </Box>
    );
  }
}
